import React, { type FunctionComponent } from 'react'
import { useDashIntl } from 'intl/intl.hooks'
import { GeneratedReportsListBreadcrumbs } from 'legacy/sections/generated-reports/components/breadcrumbs/components/GeneratedReportsListBreadcrumbs'
import { Breadcrumb } from 'legacy/components/Breadcrumbs'

export const GeneratedReportsAddBreadcrumbs: FunctionComponent = () => {
  const intl = useDashIntl()

  return (
    <GeneratedReportsListBreadcrumbs>
      <Breadcrumb>{intl.formatMessage({ id: 'generatedReports.newReport.title' })}</Breadcrumb>
    </GeneratedReportsListBreadcrumbs>
  )
}
